export const xeroCompanyConstants = {
  XERO_COMPANY_CREATE_LOADING: 'XERO_COMPANY_CREATE_LOADING',
  XERO_COMPANY_CREATE_SUCCESS: 'XERO_COMPANY_CREATE_SUCCESS',
  XERO_COMPANY_CREATE_FAILURE: 'XERO_COMPANY_CREATE_FAILURE',
  XERO_COMPANY_ERROR_RELOAD: 'XERO_COMPANY_ERROR_RELOAD',

  XERO_COMPANY_LIST_LOADING: 'XERO_COMPANY_LIST_LOADING',
  XERO_COMPANY_LIST_SUCCESS: 'XERO_COMPANY_LIST_SUCCESS',
  XERO_COMPANY_LIST_FAILURE: 'XERO_COMPANY_LIST_FAILURE',

  XERO_COMPANY_EDIT_LOADING: 'XERO_COMPANY_EDIT_LOADING',
  XERO_COMPANY_EDIT_SUCCESS: 'XERO_COMPANY_EDIT_SUCCESS',
  XERO_COMPANY_EDIT_FAILURE: 'XERO_COMPANY_EDIT_FAILURE',

  XERO_COMPANY_DELETE_LOADING: 'XERO_COMPANY_DELETE_LOADING',
  XERO_COMPANY_DELETE_SUCCESS: 'XERO_COMPANY_DELETE_SUCCESS',
  XERO_COMPANY_DELETE_FAILURE: 'XERO_COMPANY_DELETE_FAILURE'
};
